import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { db } from '../../firebase/config';
import Navbar from '../layout/Navbar';
import '../../styles/dashboard.css';

const TutorStudents = () => {
  const { userData } = useAuth();
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userData?.userType === 'tutor') {
      fetchStudents();
    }
  }, [userData]);

  const fetchStudents = async () => {
    setLoading(true);
    try {
      const bookingsQuery = query(
        collection(db, 'bookings'),
        where('tutorId', '==', userData.uid),
        orderBy('date', 'desc')
      );

      const snapshot = await getDocs(bookingsQuery);
      const map = new Map();

      snapshot.docs.forEach(doc => {
        const b = doc.data();
        const sid = b.studentId;
        if (!sid) return;
        const existing = map.get(sid) || { studentId: sid, studentName: b.studentName || 'Student', studentEmail: b.studentEmail || '', count: 0, lastBooking: null };
        existing.count += 1;
        const bookingDate = b.date && b.date.toDate ? b.date.toDate() : new Date(b.date);
        if (!existing.lastBooking || bookingDate > existing.lastBooking) existing.lastBooking = bookingDate;
        map.set(sid, existing);
      });

      setStudents(Array.from(map.values()));
    } catch (err) {
      console.error('Error fetching tutor students:', err);
    } finally {
      setLoading(false);
    }
  };

  if (userData?.userType !== 'tutor') {
    return <div className="loading">Access restricted to tutors.</div>;
  }

  return (
    <div className="dashboard-root">
      <Navbar />
      <div className="dashboard-container">
        <div className="dashboard-main">
          <div className="dashboard-header">
            <h1>Students Who Booked You</h1>
            <p>See students who have scheduled sessions with you</p>
          </div>

          {loading ? (
            <div className="loading">Loading...</div>
          ) : students.length === 0 ? (
            <div className="empty-state">
              <p>No students have booked you yet.</p>
            </div>
          ) : (
            <div className="students-list">
              <table className="bookings-table">
                <thead>
                  <tr>
                    <th>Student</th>
                    <th>Email</th>
                    <th>Bookings</th>
                    <th>Last Booking</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map(s => (
                    <tr key={s.studentId}>
                      <td>{s.studentName}</td>
                      <td>{s.studentEmail}</td>
                      <td>{s.count}</td>
                      <td>{s.lastBooking ? new Date(s.lastBooking).toLocaleString() : '-'}</td>
                      <td>
                        <button className="btn-small" onClick={() => navigate(`/dashboard/messages?user=${s.studentId}`)}>
                          Message
                        </button>
                        <button className="btn-small" onClick={() => navigate(`/dashboard/bookings?tutorId=${userData.uid}&studentId=${s.studentId}`)}>
                          View Bookings
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TutorStudents;
